import { HttpClient } from '../interceptor';

export class NotificationManagementApi{
    // 获取通知
    static getNotificationList = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/noticeController/getNotice', param).then(res => {
                if(res.data.status === 200){
                    resolve(res.data.content);
                }
            }).catch(err => console.log(err));
        })
    }

    // 新增轮播图
    static insertNotification = (content) => {
        return new Promise(resolve => {
            HttpClient.post('/api/noticeController/addNotice', { content }).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }

}